import { Image, Text, View, ScrollView, TouchableOpacity } from "react-native";
import React from "react";
import { useRouter } from "expo-router";
import { useLocalSearchParams } from "expo-router";
import { useSelector } from "react-redux";
import FooterComponent from "../component/footer";
import { useLanguage } from "./LanguageProvider";

export default function processwipsuccess() {
  const router = useRouter();
  
  const {
    item: itemParams,
    scale: itemParamscale,
    item2: itemParam2,
  } = useLocalSearchParams();

  const { t } = useLanguage();

  const item =
    typeof itemParams === "string" ? JSON.parse(itemParams) : itemParams;

  const scale =
    typeof itemParamscale === "string"
      ? JSON.parse(itemParamscale)
      : itemParamscale;

  const item2 =
    typeof itemParam2 === "string" ? JSON.parse(itemParam2) : itemParam2;

  const response =
    useSelector((state: any) => state?.scale?.postweight) || null;

  // console.log("scale", JSON.stringify(scale, null, 2));
  // console.log("item", JSON.stringify(item, null, 2));
  // console.log("item2", JSON.stringify(item2, null, 2));

  // console.log("item2", item2);
  // console.log("response", response);

  return (
    <>
      <View className="flex-1 bg-[#F17736] items-center justify-center">
        <View className="w-full h-[20%] bg-[#F17736] rounded-b-[50px]"></View>
        <View className="bottom-0 w-full h-[90%] bg-white rounded-t-[20px]"></View>

        <FooterComponent />

        {/* ScrollView ครอบเนื้อหาทั้งหมด */}
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "space-between",
            padding: 20,
          }}
          showsVerticalScrollIndicator={false}
          className="absolute mt-2 top-0 w-[90%] h-[95%] px-2 bg-white rounded-2xl border border-gray-200 shadow-md"
        >
          <View className="w-full items-center justify-center border-b border-gray-300 pb-5 mb-1">
            <Image
              source={require("../../assets/success.png")}
              className="w-24 h-24 rounded-full border-8 p-1 border-[#a3e4d7]"
            />
            <Text className="text-xl font-kanit text-gray-500 py-3">
              {/* Wip งานเข้าระบบสำเร็จ */}
              {t("wipsuccessfully_received")}
            </Text>
            <Text className="text-4xl font-kanit">
              {item?.order_number ? item?.order_number : t("no_data")}
            </Text>
          </View>

          <ScrollView className="w-full flex-1 pt-2">
            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* ชื่อ */}
                {t("name")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {item?.order_name ? item?.order_name : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* ความยาว */}
                {t("length")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {response?.meter ? response?.meter : "0.00"}{" "}
                {response?.unit ? response?.unit : ""}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* วันและเวลา */}
                {t("date_time")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* {data[0].datetime} */}
                {response?.datetime ? response?.datetime : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* จุดชั่งน้ำหนัก */}
                {t("weight_point")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {response?.weight_location
                  ? response?.weight_location
                  : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* ประเภท */}
                {t("type")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {item?.type === "good"
                  ? // ? "งานดี"
                    t("good")
                  : item?.type === "waste"
                  ? // ? "งานเสีย"
                    t("waste")
                  : "Wip"}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* จัดทำโดย */}
                {t("created_by")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {response?.empname ? response?.empname : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between border-b border-gray-300 py-2 mb-2"></View>

            {/* <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                น้ำหนักมาตรฐาน
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {data[0].standard}
              </Text>
            </View> */}
            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* จำนวน */}
                {t("quantity")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {item?.meter ? item?.meter : t("no_data")}{" "}
                {item?.unit ? item?.unit : ""}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* น้ำหนักที่ชั่งได้ */}
              {t("weight_measured")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {response?.weight ? response?.weight : "0.00"} KG.
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* หมายเลขภาชนะ */}
                {t("container_number")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {item?.container_id ? item?.container_id : t("no_data")}
              </Text>
            </View>

            <View className="flex flex-row items-center justify-between py-2">
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {/* Material Document */}
                {t("material_document")}
              </Text>
              <Text className="text-xl text-gray-600 font-kanit py-1">
                {response?.materialdoc?.materialDoc
                  ? response?.materialdoc?.materialDoc
                  : t("no_data")}
              </Text>
            </View>
          </ScrollView>

          <View className="flex flex-row items-center justify-between py-2 border-t pt-5 border-gray-300">
            <View className="w-[100%] items-center justify-center">
              <TouchableOpacity
                // onPress={() => router.push("/screens/print")}
                //  const { scale } = useLocalSearchParams();
                onPress={() =>
                  router.push({
                    pathname: "/screens/order_scales",
                    params: {
                      // machine_code: JSON.stringify(item2?.machine_code),
                      machine_code: item2?.machine_code,
                      item: JSON.stringify(item2),
                    },
                  })
                }
                className="w-full bg-[#58d68d] py-3 rounded-xl items-center shadow-sm"
              >
                <Text className="text-white text-lg font-kanit">
                  {/* กลับไปหน้ารายการ */}
                  {t("back_to_list")}
                </Text>
              </TouchableOpacity>
            </View>

            {/* <View className="w-[48%] flex-row items-center justify-center">
              <TouchableOpacity
                onPress={() =>
                  router.push({
                    pathname: "/screens/location",
                    params: {
                      item: JSON.stringify(item),
                      item2: JSON.stringify(item2),
                      forklift: JSON.stringify(forklift),
                    },
                  })
                }
                className="w-full bg-[#58d68d] py-3 rounded-xl items-center shadow-sm"
              >
                <Text className="text-white text-lg font-kanit">
                  เลือกสถานที่จัดเก็บ
                </Text>
              </TouchableOpacity>
            </View> */}
          </View>
        </ScrollView>
      </View>
    </>
  );
}
